import React, { createContext, useContext, useState } from 'react';

const DrawerContext = createContext();

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};

export const DrawerProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);

  const toggleDrawer = () => {
    setDrawerOpen(prev => !prev);
  };

  const value = {
    drawerOpen,
    setDrawerOpen,
    toggleDrawer,
    scrollPosition,
    setScrollPosition
  };

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};